import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "sprout-ui-dom/dist/Button";
import { ArrowBackIosOutlined } from "sprout-ui-icons";
import Dialog from "../../Dialog";
import LabelEditColorDialogInner from "./LabelEditColorDialogInner";
const LabelEditColorDialog = (props)=>{
    const { open , onRequestClose , label  } = props;
    return /*#__PURE__*/ _jsx(Dialog, {
        contextualTitle: "Change label color",
        hideContextualActionBar: "desktop",
        leftAction: /*#__PURE__*/ _jsx(Button, {
            color: "white.100",
            variant: "circle-bright-blue-bg",
            onClick: onRequestClose,
            children: /*#__PURE__*/ _jsx(ArrowBackIosOutlined, {})
        }),
        open: open,
        onRequestClose: onRequestClose,
        children: /*#__PURE__*/ _jsx(LabelEditColorDialogInner, {
            label: label,
            onRequestClose: onRequestClose
        })
    });
};
export default LabelEditColorDialog;
